export default __webpack_public_path__ + "static/media/Icon-03.fe48aa71.png";